import { searchFormHelper } from './search-form';
import { abbreviate, formatMoney, formatter } from './util';
import { medicalDeviceGroupHelper } from './medical-device-group';

var medicalDeviceHelper = (function ($) {
	var appendMedicalDeviceTableRows = function (response) {
		$('.medical-device-table .table').toggle(response.pagination.total > 0);
		$('.medical-device-table .load-more').toggle(response.pagination.currentPage < response.pagination.totalPages);
		$('.medical-device-table .no-results-container').toggle(response.pagination.total === 0);

		for (var i = 0; i < response.items.length; i++) {
			createMedicalDeviceTableRow(response.items[i]);
		}
	};

	var sortMedicalDeviceTableRows = function (response) {
		$('.medical-device-table .table').toggle(response.pagination.total > 0);
		$('.medical-device-table .load-more').toggle(response.pagination.currentPage < response.pagination.totalPages);
		$('.medical-device-table .no-results-container').toggle(response.pagination.total === 0);

		$('.medical-device-table .table tbody').empty();

		for (var i = 0; i < response.items.length; i++) {
			createMedicalDeviceTableRow(response.items[i]);
		}
	};

	var createMedicalDeviceTableRow = function (medicalDevice) {
		var tableRow = $('<tr>');
		var warnings = [];

		if (medicalDevice.invalid) {
			tableRow.addClass('invalid');
		}

		if (medicalDevice.invalidLastNotion) {
			warnings.push(
				$('<span class="old-scau">')
					.attr(
						'title',
						'Poslední data tohoto prostředku jsou z ZPSCAU platného k ' +
							formatter.formatDate(medicalDevice.zpscau.month) +
							'.'
					)
					.text('!')
			);
		}

		if (medicalDevice.missingZpscau) {
			warnings.push($('<span class="no-zpscau">').attr('title', 'Tento prostředek nemá ZPSCAU.').text('!'));
		}

		if (medicalDevice.finishedReimbursementProcedure) {
			warnings.push(
				$('<span class="finished-reimbursement-procedure">').attr('title', 'Správní řízení ukončeno.').text('!')
			);
		}

		if (medicalDevice.ongoingReimbursementProcedure) {
			warnings.push(
				$('<span class="ongoing-reimbursement-procedure">').attr('title', 'Probíhá správní řízení.').text('!')
			);
		}

		var detailUrl = location.pathname + '/' + encodeURIComponent(medicalDevice.id) + location.search;
		var detailLink = $('<a class="btn-detail">').attr('href', detailUrl).text('detail');

		function valueOrDash(value) {
			// We want to handle numeric 0 as a correct value, but replace `undefined` or `null` with placeholder dash
			return value === 0 ? value : value || '-';
		}

		var warningsTd = $('<td class="warnings">');
		for (var i = 0; i < warnings.length; i++) {
			warningsTd.append(warnings[i]);
			warningsTd.append(' ');
		}
		tableRow.append(warningsTd);

		tableRow.append($('<td>').text(medicalDevice.code));

		var name = medicalDevice.name || '-';
		if (name !== '-') {
			var nameSupplement = valueOrDash(medicalDevice.nameSupplement);
			tableRow.append($('<td>').html('<strong>' + name + '</strong> ' + nameSupplement));
		} else {
			tableRow.append($('<td>').text(name));
		}

		var manufacturer = valueOrDash(medicalDevice.manufacturer);
		tableRow.append($('<td>').text(manufacturer && manufacturer !== '-' ? abbreviate(manufacturer, 30) : '-'));

		var prescriptionLabel = medicalDevice.prescriptionLabel;
		var abbr = $('<abbr>').text(valueOrDash(prescriptionLabel.name)).attr('title', prescriptionLabel.description);
		tableRow.append($('<td>').html(abbr));

		if (medicalDevice.groupType !== null) {
			tableRow.append(
				$('<td>').append($('<abbr title="' + medicalDevice.groupType.name + '">').text(medicalDevice.groupType.code))
			);
		} else {
			tableRow.append($('<td>').text('-'));
		}

		if (medicalDevice.categoryTree !== null) {
			tableRow.append(
				$('<td>').append(
					$('<abbr title="' + medicalDevice.categoryTree.name + '">').text(medicalDevice.categoryTree.code)
				)
			);
		} else {
			tableRow.append($('<td>').text('-'));
		}

		var finalPrice = valueOrDash(medicalDevice.finalPrice);
		tableRow.append(
			$('<td class="price-column mfc">').html(
				(finalPrice && finalPrice !== '-') || finalPrice === 0 ? formatMoney(finalPrice) : '-'
			)
		);

		var reimbursement1 = valueOrDash(medicalDevice.reimbursement1);
		tableRow.append(
			$('<td class="price-column uhr1">').html(
				(reimbursement1 && reimbursement1 !== '-') || reimbursement1 === 0 ? formatMoney(reimbursement1) : '-'
			)
		);

		var reimbursement2 = valueOrDash(medicalDevice.reimbursement2);
		tableRow.append(
			$('<td class="price-column uhr2">').html(
				(reimbursement2 && reimbursement2 !== '-') || reimbursement2 === 0 ? formatMoney(reimbursement2) : '-'
			)
		);

		var reimbursement3 = valueOrDash(medicalDevice.reimbursement3);
		tableRow.append(
			$('<td class="price-column uhr3">').html(
				(reimbursement3 && reimbursement3 !== '-') || reimbursement3 === 0 ? formatMoney(reimbursement3) : '-'
			)
		);

		var lastMonthDistributionPackagesTotalChange = '-';
		if (medicalDevice.lastMonthDistributionPackagesTotalPercentageChange !== null) {
			if (medicalDevice.lastMonthDistributionPackagesTotalPercentageChange > 0) {
				lastMonthDistributionPackagesTotalChange =
					'<span class="positive">+' + medicalDevice.lastMonthDistributionPackagesTotalPercentageChange + ' %</span>';
			} else if (medicalDevice.lastMonthDistributionPackagesTotalPercentageChange < 0) {
				lastMonthDistributionPackagesTotalChange =
					'<span class="negative">-' + medicalDevice.lastMonthDistributionPackagesTotalPercentageChange + ' %</span>';
			} else {
				lastMonthDistributionPackagesTotalChange = '<span class="same">0 %</span>';
			}
		}

		tableRow.append(
			$('<td class="number">').html(
				medicalDevice.lastMonthDistributionPackagesTotal != null
					? formatMoney(medicalDevice.lastMonthDistributionPackagesTotal, 0, ' ')
					: '-'
			)
		);
		tableRow.append($('<td class="number percent-change">').html(lastMonthDistributionPackagesTotalChange));

		tableRow.append($('<td class="item-last">').html(detailLink));

		tableRow.clickableRow('btn-detail');

		$('.table tbody').append(tableRow);
	};

	var getMedicalDeviceApiUrl = function () {
		var values = searchFormHelper.getSearchFormValues();
		var queryString = '';
		var operator = searchFormHelper.getOperatorValue();

		for (var i = 0; i < values.length; i++) {
			queryString +=
				(i === 0 ? '?' : '&') + encodeURIComponent(values[i].name) + '=' + encodeURIComponent(values[i].value);
		}

		queryString += (queryString === '' ? '?' : '&') + 'operator=' + encodeURIComponent(operator);

		return '/medical-devices' + queryString;
	};

	return {
		appendMedicalDeviceTableRows: appendMedicalDeviceTableRows,
		sortMedicalDeviceTableRows: sortMedicalDeviceTableRows,
		getMedicalDeviceApiUrl: getMedicalDeviceApiUrl,
	};
})(jQuery);

/**
 * Features of medical device search.
 */
var medicalDeviceSearch = (function ($) {
	var root;

	var init = function () {
		root = $('.medical-device-search');

		if (root.length === 0) {
			return;
		}

		var datagrid = {
			page: 1,
			order: searchFormHelper.getOrderValue() || 'default',
			sortDirection: searchFormHelper.getSortDirectionValue() || 'asc',
		};

		root.find('.search-form-container').searchForm();
		root.find('.btn-create-medical-device-group').createMedicalDeviceGroupModal('.create-medical-device-group-modal');
		root.find('.table tbody tr').clickableRow('btn-detail');
		root
			.find('.medical-device-table .btn-load-more')
			.loadMoreWithSort(
				medicalDeviceHelper.getMedicalDeviceApiUrl(),
				medicalDeviceHelper.appendMedicalDeviceTableRows,
				datagrid
			);
		$(document).on('medicalDeviceGroup.created', saveMedicalDeviceGroupFilters);
	};

	var saveMedicalDeviceGroupFilters = function (event, response) {
		medicalDeviceGroupHelper.createSaveFiltersApiRequest(response.medicalDeviceGroup.id).done(function () {
			medicalDeviceGroupHelper.redirectToMedicalDeviceGroupDetail(event, response);
		});
	};

	return {
		init: init,
	};
})(jQuery);

/**
 * Features of medical device detail.
 */
var medicalDeviceDetail = (function ($) {
	var init = function () {
		var root = $('.medical-device-detail');

		if (root.length === 0) {
			return;
		}

		root.find('.detail-tabs a').tabs('.tab-content', 'item-act');
		root
			.find('.tab-content[data-tab=delivery-procedures] .btn-detail')
			.toggleTableDetails('.table-item-showmore', 'table-item-act');
		root
			.find('.tab-content[data-tab=procedures] .btn-detail')
			.toggleTableDetails('.table-item-showmore', 'table-item-act');
	};

	return {
		init: init,
	};
})(jQuery);

export { medicalDeviceHelper, medicalDeviceSearch, medicalDeviceDetail };
